module.exports = __webpack_public_path__ + "static/img/werner-logo-hell-no-subtitle.7ce78d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/werner-logo-hell-no-subtitle.svg
// module id = e115
// module chunks = 1